module.exports = __webpack_public_path__ + "img/newArrivals.2e895129.png";